import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const categoryImages: Record<string, { hero: string; thumb: string }> = {
  "wanghong-tafang": {
    hero: "https://readdy.ai/api/search-image?query=A%20dramatic%20theatrical%20scene%20of%20Chinese%20social%20media%20influencers%20falling%20from%20pedestals%2C%20metaphorical%20interpretation%2C%20dark%20red%20and%20gold%20tones%2C%20cinematic%20lighting%20with%20spotlights%2C%20clean%20minimal%20composition%2C%20editorial%20style&width=800&height=600&seq=cat-wanghong-tafang-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=A%20metaphorical%20scene%20showing%20Chinese%20internet%20gossip%20and%20entertainment%20news%2C%20dramatic%20red%20curtain%20motif%2C%20warm%20golden%20accents%2C%20cinematic%20lighting%2C%20clean%20minimal%20composition%2C%20editorial%20style%2C%20neutral%20elegant%20dark%20background&width=600&height=400&seq=cat-wanghong-tafang-thumb&orientation=landscape",
  },
  "chigua-baoliao": {
    hero: "https://readdy.ai/api/search-image?query=A%20group%20of%20people%20gathered%20around%20watching%20a%20dramatic%20scene%20unfold%20on%20a%20large%20screen%2C%20excited%20and%20shocked%20expressions%2C%20warm%20lighting%2C%20social%20commentary%20theme%2C%20editorial%20photography%20style%2C%20clean%20composition%2C%20deep%20burgundy%20and%20gold%20accents&width=800&height=600&seq=cat-chigua-baoliao-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=A%20crowd%20watching%20a%20dramatic%20revelation%20on%20a%20phone%20screen%2C%20shocked%20expressions%2C%20warm%20lighting%2C%20editorial%20style%2C%20clean%20dark%20background%2C%20cinematic%20mood&width=600&height=400&seq=cat-chigua-baoliao-thumb&orientation=landscape",
  },
  "mingxing-bagua": {
    hero: "https://readdy.ai/api/search-image?query=Celebrity%20silhouettes%20behind%20frosted%20glass%20with%20dramatic%20backlighting%2C%20paparazzi%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20flash%20photography%20effect%2C%20editorial%20style%2C%20clean%20composition%2C%20warm%20golden%20and%20deep%20red%20tones&width=800&height=600&seq=cat-mingxing-bagua-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=A%20paparazzi%20style%20photo%20of%20a%20red%20carpet%20event%20with%20camera%20flashes%2C%20dramatic%20lighting%2C%20dark%20elegant%20background%2C%20editorial%20photography&width=600&height=400&seq=cat-mingxing-bagua-thumb&orientation=landscape",
  },
  "zhibo-fanju": {
    hero: "https://readdy.ai/api/search-image?query=A%20live%20streaming%20studio%20setup%20in%20chaos%2C%20equipment%20malfunction%2C%20ring%20light%20flickering%2C%20dramatic%20moment%2C%20dark%20moody%20lighting%2C%20editorial%20photography%20style%2C%20warm%20red%20accents%2C%20clean%20composition&width=800&height=600&seq=cat-zhibo-fanju-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=A%20glitching%20live%20stream%20interface%20on%20a%20monitor%20with%20dramatic%20red%20error%20overlay%2C%20dark%20studio%20setting%2C%20editorial%20style&width=600&height=400&seq=cat-zhibo-fanju-thumb&orientation=landscape",
  },
  "shejiao-reshi": {
    hero: "https://readdy.ai/api/search-image?query=Multiple%20smartphone%20screens%20floating%20in%20darkness%20showing%20viral%20social%20media%20trending%20topics%2C%20dramatic%20warm%20lighting%2C%20digital%20age%20commentary%2C%20editorial%20style%2C%20clean%20composition%2C%20deep%20burgundy%20background&width=800&height=600&seq=cat-shejiao-reshi-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20viral%20social%20media%20content%20with%20red%20trending%20indicators%2C%20dark%20background%2C%20warm%20glow%2C%20editorial%20style&width=600&height=400&seq=cat-shejiao-reshi-thumb&orientation=landscape",
  },
  "meiri-dasai": {
    hero: "https://readdy.ai/api/search-image?query=A%20grand%20award%20ceremony%20stage%20with%20a%20dramatic%20golden%20trophy%20under%20spotlight%2C%20red%20carpet%2C%20theatrical%20atmosphere%2C%20dark%20elegant%20background%2C%20editorial%20photography%20style%2C%20rich%20gold%20and%20crimson%20tones&width=800&height=600&seq=cat-meiri-dasai-hero&orientation=landscape",
    thumb: "https://readdy.ai/api/search-image?query=A%20golden%20trophy%20on%20a%20dark%20stage%20with%20dramatic%20spotlight%2C%20award%20ceremony%20vibe%2C%20editorial%20photography%2C%20clean%20dark%20background&width=600&height=400&seq=cat-meiri-dasai-thumb&orientation=landscape",
  },
};

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-4 mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            吃瓜分类
            <span className="block text-base font-body font-normal text-foreground-500 mt-1">
              每日黑料吃瓜网最新内容导航
            </span>
          </h2>
          <p className="text-sm text-foreground-500 leading-relaxed lg:ml-auto lg:max-w-xs lg:text-right lg:pt-4">
            选择你感兴趣的吃瓜分类，第一时间获取网红塌房和黑料每日爆料的最新动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, index) => {
            const isLarge = index === 0;
            const images = categoryImages[cat.slug];
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`group rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer overflow-hidden border border-background-200/70 hover:border-primary-300 ${
                  isLarge ? "lg:col-span-1 lg:row-span-2" : ""
                }`}
              >
                {isLarge ? (
                  <div className="flex flex-col h-full">
                    <div className="relative w-full h-56 overflow-hidden">
                      <img
                        src={images.hero}
                        alt={cat.name}
                        title={`每日黑料 - ${cat.name}`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-2">
                          <i className={`${cat.icon} text-white text-lg w-5 h-5 flex items-center justify-center`}></i>
                        </div>
                        <h3 className="text-xl font-heading font-bold text-white">{cat.name}</h3>
                      </div>
                    </div>
                    <div className="p-5 flex-1 flex flex-col justify-between">
                      <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                      <span className="text-sm text-primary-500 font-medium mt-3 flex items-center gap-1 whitespace-nowrap">
                        浏览全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col">
                    <div className="p-5">
                      <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                        <i className={`${cat.icon} text-primary-500 text-lg w-5 h-5 flex items-center justify-center`}></i>
                      </div>
                      <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">{cat.name}</h3>
                    </div>
                    <div className="relative w-full h-40 overflow-hidden">
                      <img
                        src={images.thumb}
                        alt={cat.name}
                        title={`每日黑料 - ${cat.name}`}
                        className="w-full h-full object-cover object-top"
                        loading="lazy"
                      />
                    </div>
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}